/* eslint-disable */

/**
 * @deprecated does nothing
 */
export default {
  attach: function attach() {},
  detach: function detach() {}
};